<template>
    <div class="login">
        <b-col sm="12" lg="12" class="mandatory-note text-center">
            <p>* Pflichtfelder bitte ausfüllen</p>
        </b-col>
        <b-col class="pl-0 pr-0 mb-15 mt-15" sm="12" lg="12">
            <h3 class="h5">McDonald's Junior Club Login</h3>
        </b-col>

        <div class="form-row">
            <div class="col-12 mb-15 mt-15 pl-0 pr-0 form-group floating-label">
                <span v-if="valid('username')" class='invalid-feedback'>Bitte gültige E-Mail-Adresse eingeben</span>
                <b-form-input type="email" @keyup.enter="logIn" v-validate="'required|email'" name="username"
                              placeholder="Username"
                              v-model="username"/>
                <label>E-Mail *</label>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 mb-15 mt-30 pl-0 pr-0 form-group floating-label">
                <span v-if="valid('password')" class='invalid-feedback'>Bitte Passwort eingeben</span>
                <b-form-input class="mb-10" @keyup.enter="logIn" type="password" v-validate="'required'" name="password"
                              placeholder="Passwort" v-model="password"/>
                <label>Passwort *</label>
                <router-link to="/passwort-vergessen" class="link link-small">Passwort vergessen?</router-link>
            </div>
        </div>

        <b-col sm="8" lg="4" offset-lg="4" offset-sm="2" class="mb-40 mt-30 text-center">
            <button class="btn btn-primary bg-gradient-primary mb-30"
                    :disabled="!completed"
                    type="button"
                    @keyup.enter="logIn"
                    @click="logIn">Login
            </button>
        </b-col>


    </div>
</template>
<style lang="scss">
    @import '../styles/components/login';
</style>
<script>

    import {apiLoginParent} from "../utils/api";
    import bcrypt from "bcryptjs";

    export default {
        name: 'loginComponent',

        data: () => {
            return {
                showPw: false,
                username: '',
                password: '',
                error: false
            };
        },
        methods: {
            logIn() {

                let salt = '$2a$10$Y9WDFNqH6NSSjS7e0RcjNe',
                    pwd = bcrypt.hashSync(this.password, salt);

                apiLoginParent({
                    "email": this.username,
                    "passwordhash": pwd
                })
                    .then(response => {

                        if (response.data.code === 0) {
                            this.$store.commit('login', true);
                            this.$store.commit('user', {email: this.username, password: pwd});
                            this.$router.push({path: '/profil'});
                        } else if (response.data.code === 1) {
                            this.error = true;
                            this.password = '';
                            this.$toasted.error('E-Mail-Adresse oder Passwort nicht korrekt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        }
                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });
            },
            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            },
        },
        computed: {
            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].valid)
            }
        }
    };
</script>
